export const DOUBLE_ALBERT = 'doubleAlbert'
export const ARRIVED = 'arrived'
export const JUDGMENTAL = 'judgmental'
export const CONCERNED = 'concerned'
